import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const days = [
  { d: "MON", v: 54, s: "STEADY" },
  { d: "TUE", v: 38, s: "THIN" },
  { d: "WED", v: 28, s: "PRESSURED" },
  { d: "THU", v: 79, s: "OPEN", hot: true },
  { d: "FRI", v: 66, s: "STEADY" },
  { d: "SAT", v: 71, s: "OPEN" },
  { d: "SUN", v: 45, s: "THIN" },
];

export const TransitForecast = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  return (
    <div ref={ref} data-testid="science-transit-forecast">
      <div className="grid grid-cols-7 gap-1.5 sm:gap-3 items-end">
        {days.map((day, i) => (
          <div key={day.d} className="flex flex-col items-center" data-testid={`science-forecast-day-${day.d.toLowerCase()}`}>
            {day.hot ? (
              <>
                <span className="font-mono-brand text-[9px] text-[#FF4D0A] mb-2 sm:hidden">{day.v}</span>
                <span className="hidden sm:block font-mono-brand text-[9px] tracking-[0.14em] text-[#FF4D0A] mb-2 whitespace-nowrap">
                  YOUR WINDOW
                </span>
              </>
            ) : (
              <span className="font-mono-brand text-[9px] sm:text-[10px] text-[#6E7178] mb-2">{day.v}</span>
            )}
            <div className="w-full h-28 sm:h-36 bg-[#F2F0EB]/[0.05] flex items-end">
              <motion.div
                className="w-full"
                style={{ background: day.hot ? "#FF4D0A" : "#2A2C30" }}
                initial={{ height: 0 }}
                animate={inView ? { height: `${day.v}%` } : { height: 0 }}
                transition={{ duration: 1.1, delay: 0.1 + i * 0.09, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
            <span className="font-mono-brand text-[9px] sm:text-[10px] tracking-[0.15em] text-[#9DA1A8] mt-3">{day.d}</span>
            <span
              className="font-mono-brand text-[7px] sm:text-[8px] tracking-[0.12em] mt-1 hidden sm:block"
              style={{ color: day.hot ? "#FF4D0A" : "#6E7178" }}
            >
              {day.s}
            </span>
          </div>
        ))}
      </div>
      <p className="text-center text-xs text-[#6E7178] font-mono-brand tracking-[0.18em] uppercase mt-6">
        Seven days of conditions. You still steer.
      </p>
    </div>
  );
};
